/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Enter your tiles to see every playable word by length. (Blank tiles aren't supported yet — enter the letters you have.)`)
};

const es_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Introduce tus fichas para ver todas las palabras jugables por longitud. (Las fichas en blanco aún no son compatibles: introduce las letras que tengas.)`)
};

const de_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Gib deine Buchstabensteine ein, um alle spielbaren Wörter nach Länge zu sehen. (Blanko-Steine werden noch nicht unterstützt – gib die Buchstaben ein, die du hast.)`)
};

const nl_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Voer je letterblokjes in om elk speelbaar woord op lengte te zien. (Blanco stenen worden nog niet ondersteund — voer de letters in die je hebt.)`)
};

const fr_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Saisissez vos lettres pour voir tous les mots jouables par longueur. (Les jokers ne sont pas encore pris en charge — saisissez les lettres que vous avez.)`)
};

const it_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Inserisci le tue tessere per vedere ogni parola giocabile per lunghezza. (Le tessere jolly non sono ancora supportate: inserisci le lettere che hai.)`)
};

const pt_br2_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Digite suas peças para ver todas as palavras jogáveis por tamanho. (Peças curinga ainda não são suportadas — digite as letras que você tem.)`)
};

const pt_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Introduza as suas peças para ver todas as palavras jogáveis por comprimento. (As peças em branco ainda não são suportadas — introduza as letras que tem.)`)
};

const ja_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、使えます。手持ちのタイルを入力すると、使用可能なすべての単語が長さ別に表示されます（ブランクタイルには現在対応していません。実際に持っている文字を入力してください）。`)
};

const zh_wu_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。输入你的字母牌，即可按长度查看所有可用的单词。（目前暂不支持空白牌，请输入你实际拥有的字母。）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_faq3_a", locale)
	if (locale === "en") return en_wu_hub_faq3_a(inputs)
	if (locale === "es") return es_wu_hub_faq3_a(inputs)
	if (locale === "de") return de_wu_hub_faq3_a(inputs)
	if (locale === "nl") return nl_wu_hub_faq3_a(inputs)
	if (locale === "fr") return fr_wu_hub_faq3_a(inputs)
	if (locale === "it") return it_wu_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_faq3_a(inputs)
	if (locale === "pt") return pt_wu_hub_faq3_a(inputs)
	if (locale === "ja") return ja_wu_hub_faq3_a(inputs)
	return zh_wu_hub_faq3_a(inputs)
};